import { createStore } from 'redux';
import { RootState } from '../services/storage';
import { ActionType } from './action';
import { appStateReducer } from './reducer';

const store = createStore<RootState, ActionType, any, any>(appStateReducer);

export default store;
